import type { IconData } from '@stacksjs/iconify-core'

export const sy4x3: IconData = {
  "body": "<path d=\"M0 0h640v480H0Z\"/><path fill=\"#fff\" d=\"M0 0h640v320H0Z\"/><path fill=\"#007a3d\" d=\"M0 0h640v160H0Z\"/><path fill=\"#ce1126\" d=\"m101 300l39-120l39 120l-102-74.2h126M461 300l39-120l39 120l-102-74.2h126M281 300l39-120l39 120l-102.1-74.2h126.2\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default sy4x3
